module.exports = __webpack_public_path__ + "static/media/silverring.73a1cb55.jpg";